var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHacker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 270.701,
    y2: 34.898
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 232.855,
    y2: 144.039
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.079,
    x2: 253.079,
    y1: 220.239,
    y2: 122.466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.079,
    x2: 253.079,
    y1: 149.591,
    y2: 278.824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9766e"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 108.776,
    y2: 273.787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    stopColor: "#0d5066",
    stopOpacity: 0.123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3102,
    stopColor: "#1c657b",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    stopColor: "#35889e",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#58b8ce",
    stopOpacity: 0.799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76e2f8"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 450.488,
    y2: 531.935
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8fc5e9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56a4c8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2d8db1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147ea2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.996,
    x2: 279.243,
    xlinkHref: "#lg3",
    y1: 461.932,
    y2: 571.662
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.08,
    x2: 420.502,
    xlinkHref: "#lg2",
    y1: 285.084,
    y2: 523.506
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.58,
    x2: 282.217,
    y1: 348.585,
    y2: 385.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 420.311,
    y2: 484.371
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.583,
    x2: 152.583,
    xlinkHref: "#lg2",
    y1: 468.999,
    y2: 485.678
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.417,
    x2: 357.417,
    xlinkHref: "#lg2",
    y1: 468.999,
    y2: 485.678
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.485,
    x2: 374.19,
    xlinkHref: "#lg1",
    y1: 107.494,
    y2: 279.199
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 216.429,
    fill: "url(#SVGID_1_)",
    rx: 155.929,
    ry: 75.466
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 196.858,
    fill: "url(#SVGID_2_)",
    rx: 143.65,
    ry: 95.038
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.079 265.238c-51.495 0-93.239-41.744-93.239-93.239v-69.456c0-51.494 41.744-93.239 93.239-93.239 51.494 0 93.239 41.745 93.239 93.239v69.457c0 51.494-41.744 93.238-93.239 93.238z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.376 205.338h-10.594c-8.49 0-15.104-7.364-14.195-15.804l5.539-51.487h27.907l5.539 51.487c.908 8.44-5.706 15.804-14.196 15.804z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m401.352 212.838c.02.22.048.439.065.659-2.978-118.668-67.39-213.497-146.417-213.497s-143.439 94.829-146.417 213.497c.016-.22.045-.439.065-.659-.108 1.19-.169 2.387-.169 3.591 0 41.679 65.6 75.466 146.521 75.466s146.521-33.787 146.521-75.466c0-1.204-.061-2.4-.169-3.591z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53.329 461.66v13.248c0 6.13 2.74 11.939 7.47 15.838l16.396 13.516c4.5 3.71 10.151 5.738 15.983 5.738h323.643c5.832 0 11.483-2.029 15.983-5.738l16.396-13.516c4.73-3.899 7.47-9.708 7.47-15.838v-13.248c0-9.656-7.827-17.483-17.483-17.483h-368.375c-9.656 0-17.483 7.827-17.483 17.483z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.443 477.037c.556 5.33 3.177 10.265 7.356 13.709l16.396 13.516c4.5 3.71 10.151 5.738 15.983 5.738h323.643c5.832 0 11.483-2.029 15.983-5.738l16.396-13.516c4.178-3.444 6.8-8.38 7.356-13.709z",
    fill: "url(#SVGID_7_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m422.175 471.759h-334.35c-12.937 0-23.424-10.487-23.424-23.424v-180.661c0-12.937 10.487-23.424 23.424-23.424h334.351c12.937 0 23.424 10.487 23.424 23.424v180.661c-.001 12.936-10.488 23.424-23.425 23.424z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 358.004,
    fill: "url(#SVGID_9_)",
    r: 35.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.401 388.225v60.862c0 12.521 10.835 22.672 24.201 22.672h332.796c13.366 0 24.201-10.15 24.201-22.672v-60.862z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166.423 482.394h-27.68c-5.023 0-9.095-4.072-9.095-9.095v-3.559c0-5.023 4.072-9.095 9.095-9.095h27.68c5.023 0 9.095 4.072 9.095 9.095v3.559c0 5.023-4.072 9.095-9.095 9.095z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.257 482.394h-27.68c-5.023 0-9.095-4.072-9.095-9.095v-3.559c0-5.023 4.072-9.095 9.095-9.095h27.68c5.023 0 9.095 4.072 9.095 9.095v3.559c0 5.023-4.071 9.095-9.095 9.095z",
    fill: "url(#SVGID_12_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m410.818 213.497c-3.189-40.32-71.727-72.535-155.818-72.535s-152.629 32.215-155.818 72.535c3.169-118.668 71.717-213.497 155.818-213.497s152.649 94.829 155.818 213.497z",
    fill: "url(#SVGID_13_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHacker);
export default __webpack_public_path__ + "static/media/icon-hacker.3e28af16cdf79b7ac8f6cd7279989130.svg";
export { ForwardRef as ReactComponent };